import type { FallbackRender } from "@sentry/react";

import * as Sentry from "@sentry/react";
import { useContext } from "react";

import { AuthContext } from "~/auth/AuthProvider";
import SentryFallback from "~/helpers/SentryFallback";
import SentryRouteFallback from "~/helpers/SentryRouteFallback";

interface SentryErrorBoundaryProps {
	children: React.JSX.Element;
	onError?: () => void;
	onReset?: () => void;
	pageTitle?: string;
	showDialog: boolean;
}

const buildRouteFallback =
	(pageTitle: string): FallbackRender =>
	(fallbackProps) => <SentryRouteFallback {...fallbackProps} pageTitle={pageTitle} />;

const SentryErrorBoundary = (props: SentryErrorBoundaryProps) => {
	const { children, onError, onReset, pageTitle, showDialog } = props;

	const authContext = useContext(AuthContext);

	return (
		<Sentry.ErrorBoundary
			dialogOptions={{
				user: {
					email: authContext.currentUser?.email,
					name: authContext.currentUser?.displayName || authContext.currentUser?.email
				}
			}}
			fallback={pageTitle ? buildRouteFallback(pageTitle) : SentryFallback}
			onError={onError}
			onReset={onReset}
			showDialog={showDialog}
		>
			{children}
		</Sentry.ErrorBoundary>
	);
};

export default SentryErrorBoundary;
